module.exports = __webpack_public_path__ + "img/futurehustlers.5a095555.png";